var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuildWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_387",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_387)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.477 21.1038L11.177 14.773C10.8243 14.9257 10.4659 15.0433 10.1018 15.126C9.73743 15.2087 9.35093 15.25 8.94226 15.25C7.34509 15.25 5.98751 14.691 4.86951 13.573C3.75134 12.4548 3.19226 11.0972 3.19226 9.5C3.19226 8.98333 3.25801 8.48942 3.38951 8.01825C3.52084 7.54708 3.70768 7.09867 3.95001 6.673L7.54226 10.2462L9.68851 8.1L6.13476 4.527C6.56026 4.28467 7.00568 4.09458 7.47101 3.95675C7.93634 3.81892 8.42676 3.75 8.94226 3.75C10.5396 3.75 11.8973 4.309 13.0153 5.427C14.1333 6.54517 14.6923 7.90283 14.6923 9.5C14.6923 9.92183 14.6525 10.3148 14.573 10.6788C14.4935 11.0429 14.3743 11.3949 14.2153 11.7348L20.5463 18.0348C20.7206 18.2113 20.8078 18.4246 20.8078 18.6748C20.8078 18.9249 20.7213 19.1365 20.5483 19.3095L18.7325 21.1252C18.5595 21.2981 18.3506 21.3813 18.1058 21.375C17.8609 21.3685 17.6513 21.2781 17.477 21.1038ZM18.1155 19.604L19.0308 18.6885L12.3713 12.0288C12.6519 11.6826 12.8589 11.2887 12.9923 10.847C13.1256 10.4053 13.1923 9.95633 13.1923 9.5C13.1923 8.391 12.7961 7.40958 12.0038 6.55575C11.2114 5.70192 10.2088 5.28333 8.99601 5.3L11.1635 7.46725C11.3442 7.64808 11.4345 7.859 11.4345 8.1C11.4345 8.341 11.3442 8.55192 11.1635 8.73275L8.17501 11.7213C7.99418 11.9019 7.78326 11.9923 7.54226 11.9923C7.30126 11.9923 7.09034 11.9019 6.90951 11.7213L4.74226 9.55375C4.74476 10.8371 5.17618 11.8573 6.03651 12.6145C6.89684 13.3715 7.86543 13.75 8.94226 13.75C9.37993 13.75 9.81759 13.6849 10.2553 13.5548C10.6928 13.4248 11.0929 13.2213 11.4558 12.9443L18.1155 19.604Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildWhite);
export default __webpack_public_path__ + "static/media/build-white.ca3e7408aee8ff17f90a62b5694554c2.svg";
export { ForwardRef as ReactComponent };